import React, { useContext, useEffect, useState } from "react";

export interface DarkModeInformation {
	isEnabled: boolean;
}

export interface DarkModeProviderProps {
	children: React.ReactNode;
}

export const DarkModeProvider = ({ children }: DarkModeProviderProps): React.JSX.Element => {
	const [darkModeInformation, setDarkModeInformation] = useState<DarkModeInformation | null>(null);

	useEffect(() => {
		setDarkModeInformation(getDarkModeFromWindow());
	}, []);

	useEffect(() => {
		const onChange = (e: MediaQueryListEvent) => {
			setDarkModeInformation({ isEnabled: e.matches });
		};

		window
			.matchMedia("(prefers-color-scheme: dark)")
			.addEventListener("change", onChange);

		return () => {
			window
				.matchMedia("(prefers-color-scheme: dark)")
				.removeEventListener("change", onChange);
		};
	}, []);

	if (!darkModeInformation) {
		return <></>;
	}

	return (
		<ctx.Provider value={darkModeInformation}>
			{children}
		</ctx.Provider>
	);
};

const getDarkModeFromWindow = (): DarkModeInformation => ({ isEnabled: window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches });

const ctx = React.createContext(getDarkModeFromWindow());

export const useDarkModeInformation = () => useContext(ctx);
